import * as React from 'react';

import styled, { css } from 'styled-components';

import { motion } from 'framer-motion';

export interface CircleCheckFilledIconProps {
  className?: string;
  iconSize?: number;
  noAnimation?: boolean;
  dark?: boolean;
  customColor?: string;
  noCircle?: boolean;
  onClick?: (ev: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
}

export const CircleCheckFilledIcon: React.FC<CircleCheckFilledIconProps> = (
  props
) => {
  const path = {
    hidden: {
      pathLength: 0,
    },
    visible: {
      pathLength: 1,
      transition: {
        duration: 4,
        type: 'spring',
        stiffness: 50,
      },
    },
  };

  return (
    <svg
      className={props.className}
      onClick={(ev) => (props.onClick ? props.onClick(ev) : null)}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Circle width="32" height="32" rx="16" />
      <motion.path
        d="M10.666 16.1906L14.5448 20.0002L21.3327 13.3335"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        variants={props.noAnimation ? undefined : path}
      />
    </svg>
  );
};

export default styled(CircleCheckFilledIcon)`
  width: ${(props) => (props.iconSize ? props.iconSize : '32')}px;
  height: ${(props) => (props.iconSize ? props.iconSize : '32')}px;

  .path,
  .circle {
    fill: none;
    transition: stroke
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`};
  }

  .path,
  .circle {
    stroke: ${({ theme }) => theme.colors.success};
  }

  ${(props) =>
    props.noAnimation
      ? css`
          .path,
          .circle {
            opacity: 1;
            animation: none;
            stroke-dasharray: 0;
            stroke-dashoffset: 0;
          }
        `
      : null}

  ${(props) =>
    props.noCircle
      ? css`
          .circle {
            display: none;
          }
        `
      : null}

  ${(props) =>
    props.customColor
      ? css`
          .circle,
          .path {
            stroke: ${props.customColor};
          }
        `
      : null}
`;

const Circle = styled.rect`
  fill: ${({ theme }) => theme.colors.green};
`;
